import React, { useState } from 'react';
import { Button as AdminButton, useRecordContext, useTranslate } from 'react-admin';
import NoteIcon from '@mui/icons-material/Note';
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import { useSnackbar } from 'notistack';

var note = [];

function NoteDialog() {
    const [open, setOpen] = useState(false);
    const translate = useTranslate();
    const {enqueueSnackbar} = useSnackbar();
    const record = useRecordContext();

    const handleClose = () => {
        setOpen(false);
        note = [];
    }

    const handleOpen = () => {
        note = [];
        if (record.note) note = record.note.split(/\r?\n/);
        setOpen(true);
    }

    const showMessage = (message, level) => {
        enqueueSnackbar(message, {
            variant: level,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            autoHideDuration: 3000,
        });
    }


    return (
        <div>
            <AdminButton label='tim.note.button_label' onClick={handleOpen.bind(this)} >
                <NoteIcon />
            </AdminButton>
            <Dialog
                disableEnforceFocus
                onClose={handleClose.bind(this)}
                aria-labelledby="simple-dialog-title"
                open={open}
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="simple-dialog-title">Note</DialogTitle>
                <DialogContent>
                    {note.map(line => (
                        <DialogContentText id="alert-dialog-slide-description">
                            {line}
                        </DialogContentText>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose.bind(this)} color="primary" autoFocus><div>{translate('tim.note.cancel')}</div></Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default NoteDialog;
